import { gsap, ScrollTrigger, CSSPlugin } from "gsap/all";
import { mm } from "../styles/variables/MatchMedia";
import { BREAKPOINTS } from "../styles/variables/Breakpoints";
import { Observer } from "../plugins/Observer";

gsap.registerPlugin(ScrollTrigger, CSSPlugin, Observer);

const parallax = target => {
  if (!target) return;
  const mediaMatcher = mm();

  mediaMatcher.add(`(min-width: ${BREAKPOINTS.sm}px)`, context => {
    gsap.fromTo(
      target,
      { yPercent: -15 },
      {
        yPercent: 15,
        ease: "none",
        scrollTrigger: {
          trigger: target,
          scrub: 1,
        },
      }
    );
  });
};

const animations = {
  ...gsap,
  ScrollTrigger: ScrollTrigger,
  Observer: Observer,
  parallax: parallax,
};

export default animations;
